import React, { useState } from 'react'
import Dropzone from 'react-dropzone';
import { staticPathForBuildModeWithURL } from './ImageSlider';

const styleProfileBtn = {
    background: 'white',
    border: '1px solide #000',
    borderRadius: '50%'
}

const stylePlusBtn = {
    background: 'white',
    border: '1px solide #000',
}


function FileUpload(props) {

    const [Images, setImages] = useState(props?.images || []);

    const onDrop = (files) => {
        var file = files[0];
        resizeImage(file).then(file_resized => {
            if (props.isProfile) {
                setImages([file_resized]);
                props.refreshFunction([file_resized]);
            }
            else {
                setImages([...Images, file_resized]);
                props.refreshFunction([...Images, file_resized]);
            }
        });
    }

    const onDelete = (currentIndex) => {
        // const currentIndex = Images.indexOf(image);

        let newImages = [...Images]
        newImages.splice(currentIndex, 1)

        setImages(newImages)
        props.refreshFunction(newImages)
    }

    const resizeImage = function (file, maxSize = 512) {
        var reader = new FileReader();
        var image = new Image();
        var canvas = document.createElement('canvas');

        var dataURItoBlob = function (dataURI) {
            var bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
                atob(dataURI.split(',')[1]) :
                unescape(dataURI.split(',')[1]);
            var mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++)
                ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: file.type });
        };

        var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
                if (width > maxSize) {
                    height *= maxSize / width;
                    width = maxSize;
                }
            } else {
                if (height > maxSize) {
                    width *= maxSize / height;
                    height = maxSize;
                }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL(file.type);
            return new File([dataURItoBlob(dataUrl)], file.name, { path: file.path, type: file.type, lastModified: file.lastModified });
        };

        return new Promise(function (ok, no) {
            if (!file?.type.match(/image.*/)) {
                no(new Error("Invailid image file.:", file));
                return;
            }
            reader.readAsDataURL(file);
            reader.onloadend = function (readerEvent) {
                image.onload = function () { return ok(resize()); };
                image.src = readerEvent.target.result;
            };
        });
    };


    return (
        <div style={props.style || { display: 'flex', width: 'fit-content', margin: 'auto' }}>
            <Dropzone
                onDrop={onDrop}
                multiple={false}
                maxSize={800000000}
            >
                {({ getRootProps, getInputProps }) => (
                    <div style={{
                        width: '100px', height: '100px', margin: '5px auto 15px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}
                        {...getRootProps()}
                    >
                        <input {...getInputProps()} />
                        <img id='btnProfile' src={props.imgSrc || '/images/plus.png'} alt='plus'
                            style={props.isProfile ? styleProfileBtn : stylePlusBtn} />

                    </div>
                )}
            </Dropzone>

            <div style={{ display: 'flex', height: '100px', overflowX: 'scroll', maxWidth: '45vw' }}>

                {Images.map((image, index) => {
                    const fullURL = staticPathForBuildModeWithURL(image);
                    const imgID = `productImg-${index}`;
                    if (!fullURL) {
                        var fr = new FileReader();
                        fr.onload = function () {
                            if (props.isProfile) {
                                document.getElementById('btnProfile').src = fr.result;
                            }
                            else {
                                document.getElementById(imgID).src = fr.result;
                            }
                        }
                        fr.readAsDataURL(image);
                    }

                    return props.isProfile ? null :
                        <div key={imgID} onClick={() => onDelete(index)}>
                            <img id={imgID} style={{ minWidth: '100px', height: '100px' }} src={fullURL} alt={imgID} />
                        </div>
                })}

            </div>
        </div>
    )
}

export default FileUpload
